<template lang="pug">
.modal-editor
    aiq-dialog.modal-editor(:title="isAdd? $t(`${BASE_TRANSLATION_PATH}.add_title`) : $t(`${BASE_TRANSLATION_PATH}.edit_title`)",
        v-model="showModal"
        :show-close="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :before-close="handleBeforeClose"
        @closed="closeEditor")

        .field-container.full-width
            label {{ $t(`${BASE_TRANSLATION_PATH}.message_type`) }}
            aiq-select(v-model="selectedMessage.alert_type"
                size="small"
                :disabled="!isAdd"
                @change="onAlertTypeChange"
                :suffix-icon="Icon.CaretBottom"
                :clear-icon="Icon.Close"
                class="sel-segments"
                :clearable="true"
                :max-width="250")
                aiq-option(v-for="item in alertTypes",
                    :key="item.key",
                    :label="item.label"
                    :value="item.key")
        .field-container.full-width
            label {{ $t(`${BASE_TRANSLATION_PATH}.message_frequency`) }}
            aiq-select(v-model="selectedMessage.schedule_type"
                size="small"
                :suffix-icon="Icon.CaretBottom"
                :clear-icon="Icon.Close"
                class="sel-segments"
                :clearable="true"
                :max-width="250")
                aiq-option(v-for="item in scheduleTypes",
                    :key="item.key",
                    :label="item.label"
                    :value="item.key")

        .field-container.full-width
            label {{ $t(`${BASE_TRANSLATION_PATH}.message_name_`) }}
            aiq-input(v-model="selectedMessage.name"
                size="small"
                :disabled="!isAdd"
                :max-length="250")
        .field-container.full-width
            label {{ $t(`${BASE_TRANSLATION_PATH}.message`) }}
            .el-input
                .custom-rich-text-container
                    rich-text(@update="onUpdateRichTextEditor"
                        :showImageUpload="showImgUpload"
                        :inChat="false")
        .field-container.full-width
            label {{ $t(`${BASE_TRANSLATION_PATH}.segments`) }}
            aiq-select(v-model="selectedMessage.segments"
                multiple size="small" :clearable="false" :suffix-icon="Icon.CaretBottom" :clear-icon="Icon.Close" class="sel-segments")
                aiq-option(v-for="item in segments",
                    :key="item",
                    :label="item",
                    :value="item")
        .field-container.full-width
            label {{ $t(`${BASE_TRANSLATION_PATH}.rank`) }}
            aiq-tooltip(:content="$t(`${BASE_TRANSLATION_PATH}.rank_tooltip`)", placement="top")
                  fa-icon.question-mark(:icon="['fas', 'circle-question']")
            aiq-select(v-model="selectedMessage.rank"
                 size="small" :clearable="false" :suffix-icon="Icon.CaretBottom" :clear-icon="Icon.Close" class="sel-segments")
                aiq-option(v-for="item in getRank",
                    :key="item",
                    :label="item",
                    :value="item")
        .field-container
            .field-container
                label {{ $t(`${BASE_TRANSLATION_PATH}.start_end`) }}
                .field-container-flex
                  aiq-date-picker(v-model="selectedMessage.effective_date"
                              type="date"
                              placeholder="Start Date"
                              :clearable="true"
                              format="MM/DD/YYYY"
                              :max-length="100"
                              class="mobile-date-picker"
                              )
                  aiq-date-picker(v-model="selectedMessage.expiration_date"
                              :max-length="100"
                              :clearable="false"
                              format="MM/DD/YYYY"
                              class="mobile-date-picker"
                              placeholder="End Date")


            .field-container
                label {{ $t(`${BASE_TRANSLATION_PATH}.display_start`)}}
                aiq-tooltip(:content="$t(`${BASE_TRANSLATION_PATH}.timezone_tooltip`)", placement="top")
                  fa-icon.question-mark(:icon="['fas', 'circle-question']")

                .field-container-flex
                    aiq-time-picker(v-model="start_time"
                              class="mobile-time-picker"
                              format="hh:mm a"
                              :max-length="100"
                              placeholder="HH:MM")
                    aiq-time-picker(v-model="end_time"
                              class="mobile-time-picker"
                              format="hh:mm a"
                              :max-length="100"
                              placeholder="HH:MM")

            .recurring-section(v-if="selectedMessage.schedule_type === 'recurring'")
              .field-container-flex
                .field-container-inner
                    label {{ $t(`${BASE_TRANSLATION_PATH}.recurring_frequency`) }}
                    aiq-select(v-model="selectedMessage.recurring_frequency.frequency"
                      @change="updateEveryType" size="small" :clearable="false" :suffix-icon="Icon.CaretBottom" :clear-icon="Icon.Close" class="sel-recurring")
                        aiq-option(v-for="item in frequencies",
                            :key="item.key",
                            :label="item.label",
                            :max-length="250",
                            :value="item.key")
                .every-flex
                      .alternative-prompt-limit-container
                        .every-label {{ $t(`${BASE_TRANSLATION_PATH}.every`) }}
                        aiq-input-number(
                          size="small",
                          :min="1",
                          v-model="selectedMessage.recurring_frequency.every")
                      .every-type {{ everyType }}
              .field-container

                .week-options(v-if="everyType === 'Weeks'")
                  label {{ select_day_text }}
                  aiq-select(v-model="weeklyDays"
                            :suffix-icon="Icon.CaretBottom"
                            :clear-icon="Icon.Close"
                            class="sel-segments"
                            multiple size="small"
                            :clearable="true"  )
                      aiq-option(v-for="item in daysOfWeek",
                          :key="item.key",
                          :label="item.label",
                          :value="item.key")
                .month-options(v-if="everyType === 'Months'")
                  label {{ select_week_text }}
                  aiq-select(v-model="monthlyDays"
                            :suffix-icon="Icon.CaretBottom"
                            :clear-icon="Icon.Close"
                            class="sel-segments"
                            multiple size="small"
                            :clearable="true")
                      aiq-option(v-for="item in daysofTheMonth",
                          :key="item",
                          :label="item",
                          :value="item")

        template(v-slot:footer)
          aiq-button(v-if="!isAdd" type="danger" :plain="true" @click="deleteMsg") {{ $t(`${BASE_TRANSLATION_PATH}.delete`) }}
          aiq-button(@click="closeEditor") {{ $t(`global.cancel`) }}
          aiq-button(type="primary" @click="saveMsg") {{ $t(`global.save`) }}

</template>
<script>
import RichText from '@/components/RichText/RichText.vue';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import mitt from 'mitt';
import times from 'lodash/times';
import random from 'lodash/random';
import dayjs from '@/localPlugins/dayjs';

import { confirmBeforeDialogClose } from '@/libs';

const ALERT_TYPE_KEYS = {
  BANNER: 'banner',
  INTERSTITIAL: 'interstitial',
};

const RANK_LIMIT = 5;
const SCHEDULE_TYPE_KEYS = {
  ONE_TIME: 'one-time',
  RECURRING: 'recurring',
};

export default {
  name: 'EditBannerAndInterstitialMessage',
  data() {
    return {
      BASE_TRANSLATION_PATH: 'settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages',
      showModal: true,
      bannerAndInterstitialMessage: {},
      richTextEventEmitter: mitt(),
      expirationTime: null,
      effectiveTime: null,
      originalMsg: null,
      richMsg: '',
      start_time: null,
      showImgUpload: false,
      end_time: null,
      msgChanged: false,
      weeklyDays: [],
      monthlyDays: [],
      selectedMessageClone: null,
      everyType: this.$t('settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages.every_types.day'),
      recurringFrequency: {
        frequency: '',
        every: 1,
      },
      select_week_text: this.$t('settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages.select_week'),
      select_day_text: this.$t('settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages.select_day'),
    };
  },
  provide() {
    return {
      richTextEventEmitter: this.richTextEventEmitter,
    };
  },
  components: {
    RichText,
  },
  emits: ['close-editor', 'delete-message', 'set_start_end_time', 'add-alert-key', 'update-schedule-type', 'update-message', 'save-message', 'update-every', 'reset-message'],
  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },
    selectedMessage: {
      type: Object,
      default: () => ({}),
    },
    segments: {
      type: Array,
      default: () => [],
    },
    webchatLanguageStrings: {
      type: Object,
      default: () => ({}),
    },
    lang_code: {
      type: String,
      default: 'en',
    },
    tzAbbr: {
      type: String,
      default: '',
    },
    timezone: {
      type: String,
      default: '',
    },
  },

  watch: {
    isVisible(val) {
      this.showModal = val;
    },
    selectedMessage: {
    /**
     * @function handler
     * @description Watches selectedMessage and updates message in editor
     * @param {Object} newVal New value of selectedMessage
     */
      handler(newVal) {
        //hide image upload option for banner message
        const isInterstitial = newVal.alert_type === ALERT_TYPE_KEYS.INTERSTITIAL;
        this.showImgUpload = isInterstitial;

        const data = get(this.webchatLanguageStrings, 'webchat.banner_and_interstitial_messages', {});
        const lang_key = get(newVal, 'payload.message_langkey', '');
        const msg = data[lang_key] ? data[lang_key] : '';
        this.originalMsg = msg;
        this.$nextTick(() => {
          if (!this.isAdd || this.richMsg.length !== 0 || msg.includes('<img')) {
            this.richTextEventEmitter.emit('setText', msg);
          } else {
            this.richTextEventEmitter.emit('setText', '');
          }
        });
        this.$nextTick(() => {
          this.msgChanged = false;
        });
      },
      immediate: true,
      deep: true,
    },
    'selectedMessage.recurring_frequency.every': {
      handler(newVal) {
        if (newVal > 1) {
          this.select_week_text = this.$t('settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages.select_weeks');
          this.select_day_text = this.$t('settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages.select_days');
        } else {
          this.select_week_text = this.$t('settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages.select_week');
          this.select_day_text = this.$t('settings_tab.channels_tab.webchat_configuration.banner_and_interstitial_messages.select_day');
        }
      },
    },
  },
  computed: {
    alertTypes() {
      return [
        {
          key: ALERT_TYPE_KEYS.BANNER,
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.alert_types.banner`),
        },
        {
          key: ALERT_TYPE_KEYS.INTERSTITIAL,
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.alert_types.interstitial`),
        },
      ];
    },
    getRank() {
      return Array.from({ length: RANK_LIMIT }, (_, i) => i + 1);
    },
    scheduleTypes() {
      return [
        {
          key: SCHEDULE_TYPE_KEYS.ONE_TIME,
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.schedule_types.one_time`),
        },
        {
          key: SCHEDULE_TYPE_KEYS.RECURRING,
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.schedule_types.recurring`),
        },
      ];
    },
    daysOfWeek() {
      return [
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.days_of_week.sunday`),
          key: 0,
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.days_of_week.monday`),
          key: 1,
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.days_of_week.tuesday`),
          key: 2,
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.days_of_week.wednesday`),
          key: 3,
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.days_of_week.thursday`),
          key: 4,
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.days_of_week.friday`),
          key: 5,
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.days_of_week.saturday`),
          key: 6,
        },
      ];
    },
    daysofTheMonth() {
      //generate an array of numbers from 1 - 31
      return Array.from({ length: 31 }, (_, i) => i + 1);
    },
    isAdd() {
      return !this.selectedMessage.id;
    },

    frequencies() {
      return [
        {
          key: 'daily',
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.frequencies.daily`),
        },
        {
          key: 'weekly',
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.frequencies.weekly`),
        },
        {
          key: 'monthly',
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.frequencies.monthly`),
        },
      ];
    },
  },
  async mounted() {
    if (this.selectedMessage.id) {
      this.start_time = get(this.selectedMessage, 'start_time', null) ? this.formatDate(get(this.selectedMessage, 'start_time')) : null;
      this.end_time = get(this.selectedMessage, 'end_time', null) ? this.formatDate(get(this.selectedMessage, 'end_time')) : null;

      this.weeklyDays = get(this.selectedMessage, 'date_interval.recurring_options.days_of_week', []);
      this.monthlyDays = get(this.selectedMessage, 'date_interval.recurring_options.days_of_month', []);

      if (this.selectedMessage.alert_type === ALERT_TYPE_KEYS.INTERSTITIAL) {
        this.showImgUpload = true;
      }
    }
    if (!this.selectedMessage.recurring_frequency) {
      this.selectedMessage.recurring_frequency = this.recurringFrequency;
    } else {
      this.updateEveryType(this.selectedMessage.recurring_frequency.frequency);
    }
    if (!this.selectedMessage.id) {
      this.selectedMessage.segments = [];
    }
    this.selectedMessageClone = cloneDeep(this.selectedMessage);
  },
  methods: {
    formatDate(time) {
      const today = dayjs().format('YYYY-MM-DD');
      return dayjs(`${today} ${time}`).tz(this.timezone).format('YYYY-MM-DD HH:mm:ss');
    },
    closeEditor(val) {
      if (!val || !val.length) {
        //revert back to the original message
        this.$emit('reset-message', { message: this.selectedMessageClone, originalMsg: this.originalMsg});
      }
      this.$emit('close-editor');
      this.showModal = false;
    },
    handleBeforeClose() {
      if ((!isEqual(this.selectedMessage, this.selectedMessageClone)) || this.msgChanged) {
        confirmBeforeDialogClose(this, this.closeEditor);
      } else {
        this.$emit('close-editor');
        this.showModal = false;
      }
    },

    onTimeChange(date, dateProp) {
      if (!this.selectedMessage[dateProp] || !date) {
        return;
      }
      // Extract time from the sourceDate
      const sourceTime = dayjs(date).format('HH:mm:ss');
      // Combine the extracted time with the date part of the targetDate
      this.selectedMessage[dateProp] = dayjs(`${dayjs(this.selectedMessage[dateProp]).format('YYYY-MM-DD')} ${sourceTime}`).toDate();
    },
    onUpdateRichTextEditor(msgData) {
      const msg_key = get(this.selectedMessage, 'payload.message_langkey', '');
      this.$emit('update-message', {
        key: msg_key,
        message: msgData.html,
      });
      this.richMsg = msgData.text;
      this.msgChanged = true;
    },
    /**
     * Called when the alert type changes.
     * If the selected message doesn't have an id, a random key is generated and emitted to the parent.
     * Also, schedule type is updated based on the selected alert type.
     */
    onAlertTypeChange() {
      if (!this.selectedMessage.id) {
        this.$emit('add-alert-key', {
          key: times(8, () => random(35).toString(36)).join(''), // eslint-disable-line no-magic-numbers
        });
      }
    },
    /**
     * @function updateEveryType
     * @description Updates this.everyType based on selected schedule frequency type.
     * @param {string} type - selected schedule frequency type
     */
    updateEveryType(type) {
      switch (type) {
        case 'daily':
          this.everyType = this.$t(`${this.BASE_TRANSLATION_PATH}.every_types.day`);
          break;
        case 'weekly':
          this.everyType = this.$t(`${this.BASE_TRANSLATION_PATH}.every_types.week`);
          break;
        case 'monthly':
          this.everyType = this.$t(`${this.BASE_TRANSLATION_PATH}.every_types.month`);
          break;
        default:
          this.everyType = '';
      }
    },
    /**
     * Validate the selected message and return true if valid, false if not.
     * Display a notification error if any validation fails.
     * @returns {boolean} true if valid, false if not.
     */
    validate() {
      const {
        alert_type,
        schedule_type,
        effective_date,
        expiration_date,
        recurring_frequency,
        segments,
        name,
      } = this.selectedMessage;

      if (!alert_type) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.alert_type_required`));
        return false;
      }

      if (!schedule_type && alert_type) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.schedule_type_required`));
        return false;
      }

      if (!effective_date) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.effective_date_required`));
        return false;
      }

      if (this.richMsg.trim().length === 0 && !this.originalMsg.includes('<img')) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.message_required`));
        return false;
      }

      if (!expiration_date) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.effective_date_required`));
        return false;
      }

      if (effective_date && dayjs(effective_date).isAfter(dayjs(expiration_date))) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.effective_date_after_expiration`));
        return false;
      }

      if (!name) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.name_required`));
        return false;
      }

      if (segments.length === 0) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.segments_required`));
        return false;
      }

      if (!this.end_time || !this.start_time) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.display_start_end_required`));
        return false;
      }
      if (this.start_time && this.end_time) {
        const start = dayjs(this.start_time).format('HH:mm');
        const end = dayjs(this.end_time).format('HH:mm');
        if (start >= end) {
          this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.display_start_after_end`));
          return false;
        }
      }

      if (schedule_type === SCHEDULE_TYPE_KEYS.RECURRING && !recurring_frequency.frequency) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.validation.freq_type_required`));
        return false;
      }

      return true;
    },
    /**
 * Computes an array of date strings between the effective_date and expiration_date,
 * incrementing by the frequency specified in this.selectedMessage.recurring_frequency.every.
 * Dates are formatted as 'MM/DD/YYYY'. Assumes that validation ensuring the validity of
 * effective_date and expiration_date is done prior to calling this function.
 *
 * @returns {Array} An array of date strings between effective_date and expiration_date.
 */

    computeIntervalDates() {
      //validation runs before this method, so effective_date and expiration_date are guaranteed to be valid
      const { effective_date, expiration_date } = this.selectedMessage;
      const dates = [];
      let startDate = dayjs(effective_date);
      const endDate = dayjs(expiration_date);

      if (this.selectedMessage.recurring_frequency.frequency === 'weekly' && this.weeklyDays.length === 0) {
        //if no day of the week is selected, append 0 - 6 (all days of the week)
        this.weeklyDays = this.daysOfWeek.map(day => day.key);
      }
      if (this.selectedMessage.recurring_frequency.frequency === 'monthly' && this.monthlyDays.length === 0) {
        //if no day of the month is selected, append 1 - 31 (all days of the month)
        this.monthlyDays = this.daysofTheMonth;
      }

      if (this.selectedMessage.recurring_frequency.frequency === 'weekly') {
        //for weekly, we need to find the next date that matches the selected day of the week
        while (startDate.isSameOrBefore(endDate)) {
          for (const day of this.weeklyDays) {
            if (this.weeklyDays.includes(day) && startDate.isSameOrBefore(endDate)) {
              const arbitraryDay = startDate.clone().startOf('week').day(day);
              dates.push(arbitraryDay.format('MM/DD/YYYY'));
            }
          }
          startDate = startDate.add(this.selectedMessage.recurring_frequency.every, 'week');
        }
        return dates;
      }

      if (this.selectedMessage.recurring_frequency.frequency === 'monthly') {
        //for monthly, we need to find the next date that matches the selected day of the month
        while (startDate.isSameOrBefore(endDate)) {
          for (const day of this.monthlyDays) {
            if (this.monthlyDays.includes(day) && startDate.isSameOrBefore(endDate)) {
              const arbitraryDay = startDate.clone().startOf('month').date(day);
              dates.push(arbitraryDay.format('MM/DD/YYYY'));
            }
          }
          startDate = startDate.add(this.selectedMessage.recurring_frequency.every, 'month');
        }
        return dates;
      }

      while (startDate.isSameOrBefore(endDate)) {
        dates.push(startDate.format('MM/DD/YYYY'));
        startDate = startDate.add(this.selectedMessage.recurring_frequency.every, this.everyType.toLowerCase());
      }
      return dates;
    },
    removeInValidDates(startDate, endDate, dates) {
      return dates.filter(date => {
        const mDate = dayjs(date, 'MM/DD/YYYY');
        const start = dayjs(startDate).startOf('day');
        const end = dayjs(endDate).endOf('day');
        return mDate.isSameOrAfter(dayjs(start)) && mDate.isSameOrBefore(dayjs(end));
      });
    },
    saveMsg() {
      const isValid = this.validate();
      if (!isValid) {
        return;
      }

      let affectedDates = [];
      if (this.selectedMessage.recurring_frequency.frequency && this.selectedMessage.recurring_frequency.every) {
        affectedDates = this.removeInValidDates(this.selectedMessage.effective_date, this.selectedMessage.expiration_date, this.computeIntervalDates());
      }
      const freq = this.selectedMessage.schedule_type === 'recurring' ? this.selectedMessage.recurring_frequency.frequency : '';

      this.$emit('save-message', { intervals: affectedDates,
        frequency: freq,
        start_time: this.start_time,
        end_time: this.end_time,
        recurring_options: {
          days_of_week: this.weeklyDays,
          days_of_month: this.monthlyDays,
        },
      });
    },
    deleteMsg() {
      this.$emit('delete-message');
      this.closeEditor('delete');
    },
    /**
     * Updates the every value in the selected message's recurring_frequency.
     *
     * @param {string} type - If 'add', increments the every value by 1. If 'sub', decrements the every value by 1, but
     *                        only if the every value is greater than 1.
     */
    computeEvery(type) {
      if (type === 'add') {
        this.$emit('update-every', {
          every: this.selectedMessage.recurring_frequency.every + 1,
        });
      } else {
        if (this.selectedMessage.recurring_frequency.every <= 1) {
          return;
        }
        this.$emit('update-every', {
          every: this.selectedMessage.recurring_frequency.every - 1,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.question-mark {
    padding-left: 5px;
}
.required-notice {
  float: right;
  color: red;
}
.is-required {
  margin-bottom: 10px;
}
label {
    font-size: 14px;
    color: #475669;
}

.every-label {
  margin-left: 12px;
  color: #475669;
  font-size: 14px;
  font-weight: 100
}

.alternative-prompt-limit-container {

.el-input-number {
  margin-left: 10px;
}
.el-input-number--small {
  width: 100%;
  span {
    background: transparent;
    border-radius: 0;
    top: 2px !important;
    height: 30px !important;
    font-size: 14px !important;
  }
  .el-input-number__decrease {
      right: 20px;
      left: unset;
      border-right: none;
  }
  .el-input-number__increase {
      right: 1px;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
      top: 1px;
      width: 20px;
      height: 30px;
      font-size: 10px;
      line-height: 20px;
  }
}
.el-input--small {
  .el-input__inner {
      padding-right: 40px;
      padding-left: 3px;
      height: 30px
  }
}
}

.modal-editor {
  overflow-y: auto;
  height: 300%;
}
.field-container-flex {
  display: flex;
  gap: 10px;
}
.every-flex {
  display: flex;
}

.field-container-inner {
  width: 50%;

  label {
    color: #475669;
    font-size: 14px;
    font-weight: 100;
  }
}
.input-icon-group {
  display: flex;
  align-items: center;
}

.icon-btn {
  height: 35px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.every-type {
  padding-left: 30px;
  margin-top: 35px;
  color: #475669;
  font-size: 14px;
  font-weight: 100
}
:deep(.mobile-date-picker .el-input__prefix-inner>:first-child, .el-input__prefix-inner>:first-child.el-input__icon) {
    margin-left: 0;
    margin-top: 4px;
    margin-right: 15px;
}

:deep(.el-input__inner.is-disabled) {
  background-color: var(--el-disabled-bg-color);

  .el-input__wrapper {
    background-color: inherit !important;
    box-shadow: none !important;

    input.el-input__inner {
      background-color: var(--el-disabled-bg-color) !important;
      border-color: var(--el-disabled-bg-color) !important;
    }
  }
}

:deep(.alternative-prompt-limit-container .el-input--small .el-input__inner) {
  height: 30px;
}

:deep(.alternative-prompt-limit-container .el-input-number--small span) {
  height: 26px !important;
}
</style>
